import { useState, useEffect } from "react";
import { PreinitiateServices } from "../../../services/PreinitiateServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { useSelector } from "react-redux";
import PdfIcon from "../../../assets/pdfIcon.png";
import ReuploadImageIcon from "../../../assets/reuploadIcon.svg";
import ImagesGalleryHospitalPersona from "../../../hospitalPersona/imageGallery/ImageGalleryHospitalPersona";
import ImageGalleryScreenshot from "./ImageGalleryScreenshot";
import CircularProgress from "@mui/material/CircularProgress";

const ReferenceDocFlow = ({
  caseDetails,
  isScreenshot,
  index,
  setIsScreenshotOpen,
}) => {
  const [groupedReferenceDocuments, setGroupedReferenceDocuments] =
    useState(null);
  const [referenceDocuments, setReferenceDocuments] = useState(null);

  const [selectedPdf, setSelectedPdf] = useState(-1);
  const [isLoading, setIsLoading] = useState(false);
  const [documentType, setDocumentType] = useState("ADMISSIONDOCUMENT");
  const [reUploading, setReUploading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const getDocumentsData = async () => {
    setIsLoading(true);

    try {
      const response = await PreinitiateServices.getReferenceDocuments(
        caseDetails?.id,
        documentType
      );

      let tempData = response.data;
      let modifiedData = [];
      let groupedDocs = [];
      let rejectedDocCount = 0;

      for (let doc of tempData) {
        if (doc.parentId) {
          if (groupedDocs.length === 0) {
            groupedDocs.push(doc);
            rejectedDocCount =
              doc?.status === "REJECTED"
                ? rejectedDocCount + 1
                : rejectedDocCount;
          } else {
            if (doc.parentId === groupedDocs[0].parentId) {
              groupedDocs.push(doc);
              rejectedDocCount =
                doc?.status === "REJECTED"
                  ? rejectedDocCount + 1
                  : rejectedDocCount;
            } else {
              modifiedData.push({
                parentId: groupedDocs[0].parentId,
                docs: groupedDocs,
                rejectedDocCount: rejectedDocCount,
              });
              groupedDocs = [];

              groupedDocs.push(doc);
              rejectedDocCount = doc?.status === "REJECTED" ? 1 : 0;
            }
          }
        } else {
          rejectedDocCount = doc?.status === "REJECTED" ? 1 : 0;
          modifiedData.push({
            parentId: null,
            docs: [doc],
            rejectedDocCount: rejectedDocCount,
          });
        }
      }

      // Ensure to add remaining grouped docs
      if (groupedDocs.length > 0) {
        modifiedData.push({
          parentId: groupedDocs[0].parentId,
          docs: groupedDocs,
          rejectedDocCount: rejectedDocCount,
        });
      }
      setReferenceDocuments(response.data);
      setGroupedReferenceDocuments(modifiedData);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getDocumentsData();
  }, [documentType]);
  return (
    <div>
      <div className="h-[85%] 2xl:h-[90%] overflow-y-scroll">
        <div className="flex gap-2 items-center mb-3">
          <div
            style={{ border: "1px solid #017C57" }}
            className={`text-sm ${
              documentType.includes("ADMISSION")
                ? "text-white bg-[#017C57]"
                : "text-[#017C57]"
            } rounded-full px-5 py-2 cursor-pointer `}
            onClick={() => setDocumentType("ADMISSIONDOCUMENT")}
          >
            Admission
          </div>
          <div
            style={{ border: "1px solid #017C57" }}
            className={`text-sm ${
              documentType.includes("ENHANCEMENT")
                ? "text-white bg-[#017C57]"
                : "text-[#017C57]"
            } rounded-full px-5 py-2 cursor-pointer `}
            onClick={() => setDocumentType("ENHANCEMENTDOCUMENT")}
          >
            Enhancement{" "}
          </div>
          <div
            style={{ border: "1px solid #017C57" }}
            className={`text-sm ${
              documentType.includes("DISCHARGE")
                ? "text-white bg-[#017C57]"
                : "text-[#017C57]"
            } rounded-full px-5 py-2 cursor-pointer `}
            onClick={() => setDocumentType("ONDISCHARGEDOCUMENT")}
          >
            Claim
          </div>
        </div>
        <div className="border border-solid border-[#dedede] my-3" />

        <div className="h-full flex items-start  gap-[10px] flex-wrap">
          {groupedReferenceDocuments?.length > 0 ? (
            groupedReferenceDocuments?.map((document, idx) => {
              return (
                <div
                  key={idx}
                  style={{ border: "1px solid #E4E4E4" }}
                  className={`relative rounded-[17px] p-1 ${
                    document.rejectedDocCount > 0 ? "bg-[#FFA9A9]" : "bg-white"
                  }`}
                >
                  <div className="flex gap-2 pl-2">
                    {idx + 1}{" "}
                    {document.rejectedDocCount > 0 && (
                      <div
                        className="max-w-[230px] text-sm overflow-hidden text-ellipsis whitespace-nowrap z-10"
                        title={document.docs[0]?.rejectionReason}
                      >
                        {document.docs[0]?.rejectionReason}
                      </div>
                    )}
                  </div>
                  {document?.parentId && document.docs.length > 1 ? (
                    <div className="relative">
                      <img
                        src={PdfIcon}
                        alt=""
                        width={248}
                        height={249}
                        style={{ border: "1px solid #E4E4E4" }}
                        className="object-fit rounded-[15px]"
                        onClick={() => setSelectedPdf(idx)}
                      />
                      {document?.docs[0]?.totalUnreadComments > 0 && (
                        <div className="absolute top-0 right-0 w-[16px] h-[16px] flex justify-center items-center text-[10px] text-white bg-[#ff0000]  rounded-full">
                          {document?.docs[0]?.totalUnreadComments}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="relative">
                      <img
                        src={document?.docs[0].documentUrl}
                        alt=""
                        width={248}
                        height={249}
                        style={{ border: "1px solid #E4E4E4" }}
                        className="object-fit rounded-[15px]"
                        onClick={() => setSelectedPdf(idx)}
                      />
                      {document?.docs[0]?.totalUnreadComments > 0 && (
                        <div className="absolute top-0 right-0 w-[16px] h-[16px] flex justify-center items-center text-[10px] text-white bg-[#ff0000]  rounded-full">
                          {document?.docs[0]?.totalUnreadComments}
                        </div>
                      )}
                    </div>
                  )}
                  {document?.docs[0]?.status === "REJECTED" &&
                    document.docs.length === 1 && (
                      <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-transparent">
                        {reUploading &&
                        selectedDocument.id === document?.docs[0]?.id ? (
                          <CircularProgress color="inherit" />
                        ) : (
                          <img
                            src={ReuploadImageIcon}
                            alt="re-upload-image"
                            className="cursor-pointer"
                            onClick={() => {
                              setSelectedPdf(idx);
                            }}
                          />
                        )}
                      </div>
                    )}
                  <div className="absolute bottom-0.5 left-0  w-full ">
                    <div
                      style={{
                        background: "#00000060",
                        backdropFilter: "blur(3.6976048946380615px)",
                      }}
                      className="flex w-[94%] justify-between items-center rounded-[14px] py-2 mx-auto px-1"
                    >
                      <div className="text-sm text-white leading-[18.27px] -tracking-[3%] text-ellipsis whitespace-nowrap overflow-hidden">
                        {document?.docs[0]?.description?.slice(0, -2)}
                      </div>
                      <div className="text-white text-sm mr-2">
                        {document?.docs && <div>{document?.docs?.length}</div>}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="h-full w-full flex justify-center items-center text-2xl font-bold">
              No Documents Uploaded Yet
            </div>
          )}
        </div>
      </div>
      {selectedPdf >= 0 &&
        (isScreenshot ? (
          <ImageGalleryScreenshot
            data={groupedReferenceDocuments[selectedPdf]?.docs}
            setOpen={setSelectedPdf}
            setIsScreenshotOpen={setIsScreenshotOpen}
            view={true}
            type={"referenceDocument"}
            getDocumentsData={getDocumentsData}
            index={index}
          />
        ) : (
          <ImagesGalleryHospitalPersona
            data={groupedReferenceDocuments[selectedPdf]?.docs}
            setOpen={setSelectedPdf}
            view={true}
            type={"referenceDocument"}
            getDocumentsData={getDocumentsData}
          />
        ))}
    </div>
  );
};

export default ReferenceDocFlow;
